import log from 'common/services/logging/loggers';
/**
     * @ngdoc service
     * @name services.Launcher
     *
     * @description
     * Send commands to the launcher.
     */
angular.module('services')
    .service('Launcher', ($window) => {

        const Launcher = {
            /**
                 * Activates a service.
                 * @param {string} service The service to activate.
                 */
            activateService(service) {

                this.execute(`aoe://requestServiceDeployment?service=${service}`);
                if (service !== 'antitheft') {

                    this.execute('aoe://openMiniGui');

                }

            },

            /**
                 * Resizes the modal shown by the launcher.
                 * @param {integer} width The width.
                 * @param {integer} height The height.
                 */
            resizeModal(width, height) {

                this.execute(`aoe://resize?width=${width}&height=${height}`);

            },

            /**
                 * Minimizes the modal shown by the launcher.
                 */
            minimizeModal() {

                this.execute('aoe://minimize');

            },

            /**
                 * Closes the modal shown by the launcher.
                 */
            closeModal() {

                this.execute('aoe://close');

            },

            /**
                 * Moves the modal shown by the launcher.
                 */
            moveModal() {

                this.execute('aoe://Move');

            },

            /**
                 * Opens the dashboard
                 */
            openDashboard(service) {

                this.execute(`aoe://openDashboardUrl?section=register&service=${service}`);

            },

            /**
                 * Executes a command with $window.external.Execute
                 * @param {string} command The command to be executed.
                 */
            execute(command) {

                if (!$window.external) {

                    return;

                }
                try {

                    $window.external.Execute(command);

                } catch (e) {

                    log.error({
                        type: 'ERROR',
                        cmd: 'window.external.Execute',
                        data: e.message,
                        i: -1,
                    });

                }

            },
        };

        return Launcher;

    });



// WEBPACK FOOTER //
// ./scripts/common/services/Launcher.js